import { combineReducers, configureStore, createAction } from '@reduxjs/toolkit'
import { PersistConfig, persistReducer } from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2'
import authReducer from './auth'
import sessionPersistStorage from 'redux-persist/lib/storage/session'
import { thunk } from 'redux-thunk'
import configReducer from './config'
import {
  IAuthState,
  ICommonState,
  IConfigState,
  IMasterSetupState,
  IPreAuthenState,
  IUserRoleSetupState,
} from '../shared/models/store.model'
import preAuthenReducer from './preAuthen'
import commonReducer from './common'
import masterSetupReducer from './masterSetup'
import userRoleSetUpReducer from './userRoleSetup'

export interface IAppState {
  auth: IAuthState
  config: IConfigState
  preAuthen: IPreAuthenState
  common: ICommonState
  masterSetup: IMasterSetupState
  userRoleSetup: IUserRoleSetupState
}

export const logOutApp = createAction('LOGOUT_APP')

const persistConfig: PersistConfig<IAppState> = {
  key: 'root',
  storage: sessionPersistStorage,
  blacklist: [],
  stateReconciler: autoMergeLevel2,
}

const rootReducers = combineReducers<IAppState>({
  auth: authReducer.reducer as any,
  config: configReducer.reducer as any,
  preAuthen: preAuthenReducer.reducer as any,
  common: commonReducer.reducer as any,
  masterSetup: masterSetupReducer.reducer as any,
  userRoleSetup: userRoleSetUpReducer.reducer as any,
})

export const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducers),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(thunk),
})
